module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/forward-1948a51818158e1f1df38b3db47bf187.svg";